import React, { Component } from "react";
import { connect } from "react-redux";
import { checkAuthentication, logout } from "./authentication/actions/authenticationActions"
import UsernameAndLogout from "../components/UsernameAndLogout";

const timIdeasLogo = process.env.IS_IN_WEBPACK ? require("../../images/tim-logo-header.png") : "";

const headerStyle = {
    backgroundColor: "#28313E",
    padding: 10,
    minWidth: 850
};

const imageStyle = {
    width: 128,
    height: 46
};

const contentStyle = {
    backgroundColor: "white",
    overflow: "hidden",
    borderRadius: 3,
    border: "1px solid #ddd",
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
    color: "#28313E",
    width: 850,
    margin: "0 auto",
    marginTop: -40
};

export class App extends Component {

    componentWillMount() {
        this.props.checkAuthentication();
    }

    render() {
        return (
            <div>
                <header style={headerStyle}>
                    <img src={timIdeasLogo} style={imageStyle}/>
                    { this.props.username !== null ? <UsernameAndLogout username={this.props.username} onLogout={this.props.onLogout} /> : null }
                </header>
                <div style={contentStyle}>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    username: state.authenticationStatus.emailAddress
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    checkAuthentication: () => dispatch(checkAuthentication()),
    onLogout: () => dispatch(logout())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);




/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/App.js
 **/